import shoppableImage from '../helpers/ShoppableImage';

// export default (settings, module_name, index) => {
export default (settings, module_name) => {
  const content_html = `
  <div class="Module-${module_name}__segment Module-${module_name}__Left">
    <div class="Module-${module_name}__segment-inner Module-${module_name}__Left-inner">
      ${shoppableImage(settings.left_content, settings.accent_color.accent_color)}
      <p>${settings.left_content.caption}</p>
    </div>
  </div>
  <div class="Module-${module_name}__segment Module-${module_name}__Right">
    <div class="Module-${module_name}__segment-inner Module-${module_name}__Right-inner">
      ${shoppableImage(settings.right_content, settings.accent_color.accent_color)}
      <p>${settings.right_content.caption}</p>
    </div>
  </div>
  `;
  return content_html;
};
